import { Mappable } from '../Mappable';

export const locationCategories = {
  city: 'city',
  region: 'region',
  subRegion: 'subRegion',
  country: 'country',
};

export class Location extends Mappable {
  category = locationCategories.city;
  label = '';
  locationCode = '';

  constructor(label = '', parametersValues = {}) {
    super();

    this.label = label;
    if (parametersValues['filter.region']) {
      this.category = locationCategories.region;
      this.locationCode = parametersValues['filter.region'];
    } else if (parametersValues['filter.sub_region']) {
      this.category = locationCategories.subRegion;
      this.locationCode = parametersValues['filter.sub_region'];
    } else if (parametersValues['filter.country']) {
      this.category = locationCategories.country;
      this.locationCode = parametersValues['filter.country'];
    } else {
      this.category = locationCategories.city;
      this.locationCode = parametersValues['filter.coordinates'] ? parametersValues['filter.coordinates'] : '';
    }
  }

  static map(data) {
    if (!data) return new Location();

    return new Location(data.label, data.parameters_values);
  }
}
